import React from "react";
import { Layout, Input, Row, Col, Icon, Button } from "antd";
import logo from "../../assets/logo.png";
import { Link } from "react-router-dom";

const { Header, Content } = Layout;

const success = {
  headline: {
    en: "An email was sent for you to recover your password",
    dk: "En email er sendt så du kan få et nyt password"
  },
  btn: {
    en: "Go back to sign in",
    dk: "Gå tilbage til log ind"
  }
};

class ForgotPassword extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: ""
    };
  }

  emitEmptyEmail = type => {
    this.emailInput.focus();
    this.setState({ email: "" });
  };

  onChangeValue = (e, type) => {
    this.setState({ [type]: e.target.value });
  };

  onSubmit = e => {
    e.preventDefault();
    this.props.forgotPassword(this.state.email);
  };

  render() {
    const { email } = this.state;
    const suffixEmail = email ? (
      <Icon type="close-circle" onClick={this.emitEmptyEmail} />
    ) : null;

    return (
      <Layout className="layout surveybg" style={{ height: "100%" }}>
        <Header className="" style={{ height: "15vh" }}>
          <Row>
            <Col md={12} offset={6}>
              <Link to="/">
                <div className="logo">
                  <Link to={"/"}>
                    <img alt='forgot-password' src={logo} height="70px" />
                  </Link>
                </div>
              </Link>
            </Col>
          </Row>
        </Header>
        <Content style={{ height: "75vh" }}>
          {this.props.resetSuccess ? (
            <div>
              <h1 style={{ color: "#fff" }}>
                {success.headline[this.props.language]}
              </h1>
              <Link to="/sign-in">
                <Button type="primary" size="large">
                  {success.btn[this.props.language]}
                </Button>
              </Link>
            </div>
          ) : (
            <form onSubmit={this.onSubmit}>
              <Row className="survey_content_container">
                <Col
                  md={{ span: 12, offset: 6 }}
                  xs={24}
                  style={{ paddingBottom: "20px" }}
                >
                  <Input
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                    prefix={
                      <Icon type="mail" style={{ color: "rgba(0,0,0,.25)" }} />
                    }
                    suffix={suffixEmail}
                    value={email}
                    size="large"
                    onChange={e => this.onChangeValue(e, "email")}
                    ref={node => (this.emailInput = node)}
                    required
                  />
                </Col>
                <Col md={{ span: 12, offset: 6 }} xs={24}>
                  <Button
                    htmlType="submit"
                    type="primary"
                    size="large"
                    style={{ width: "100%" }}
                    loading={this.props.isLoading}
                  >
                    Send email
                  </Button>
                  {this.props.errorMessage && (
                    <span style={{ color: "red" }}>
                      {this.props.errorMessage}
                    </span>
                  )}
                </Col>
              </Row>
            </form>
          )}
        </Content>
      </Layout>
    );
  }
}
export default ForgotPassword;



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword/index.js